module.exports = __webpack_public_path__ + "img/charles-thomson.1cf62c38.png";